$(function () {
    $('.owl-carousel').owlCarousel({
        margin: 20,
        loop: true,
        dotsEach: 1,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            }
        }
    });
});

window.scrollToTop = function(){
    $('html, body').animate({
        scrollTop: 0
    }, 0);
};